export default {
	AnalysisReportData(state) {
		return state.AnalysisReportData;
	},
	LatestAnalysisReportHistory(state) {
		return state.LatestAnalysisReportHistory;
	},
	LastRequestFilter(state) {
		return state.LastRequestFilter;
	}
};
